import { defineComponent as _defineComponent } from 'vue'
import { reactive, computed } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { required } from "@vuelidate/validators";
  import store from "@/store";
  import router from "@/router";
  import { CreateEstate } from "@/types/CreateEstate";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminStageCreate',
  setup(__props, { expose: __expose }) {
  __expose();

  const userId = router.currentRoute.value.params.userId;
  const estateId = router.currentRoute.value.params.estateId;
  const form = reactive<CreateEstate>({
    title: "",
    landownerId: userId,
    estateId: estateId,
  });
  const rules = computed(() => {
    return {
      title: { required, $autoDirty: true },
    };
  });
  const v$ = useVuelidate(rules, form);

  async function createStage() {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) return;

    store.dispatch("stage/createStage", form).then(() => {
      router.push({
        name: "AdminEstate",
        params: { userId, estateId },
      });
    });
  }

const __returned__ = { userId, estateId, form, rules, v$, createStage, reactive, computed, get useVuelidate() { return useVuelidate }, get required() { return required }, get store() { return store }, get router() { return router }, get CreateEstate() { return CreateEstate } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})